import { Chip, ChipProps } from '@mui/material';
import * as React from 'react';

const ChipVariant: React.FC<{ value: string } & ChipProps> = ({ value, ...rest }) => {
  return (
    <Chip
      {...rest}
      label={value}
      variant='outlined'
      style={{
        width: 'fit-content',
        padding: '2px',
        maxHeight: '26px',
        fontSize: '11px',
        backgroundColor: '#E0E0E0',
        color: '#999999',
        border: 'none'
      }} />
  );
};

export default ChipVariant;